var App = {
	
	_AutoRefreshMinutes: 2,
	_PopOverOptions: {trigger: 'hover', container: 'body', html: true, placement: 'auto', selector: '.has-popover'},
	_CurrentlyShownPopover: null,
	_ShowLoadingTimeout: 0,

	init: function () {
		App.WatchEvents()
		App.SetupAutocomplete()
		App.SetupPopovers()
		
		window.setTimeout(function() { App.AutoRefreshPage() }, App._AutoRefreshMinutes * 60 * 1000)

		// for dev, auto show
		//$('#BC-01').click() // reserve
		//$('#RC-05').click() // cancel
	},

	WatchEvents: function() {

		$('.reserve-button').click(function () {
			App.HideSearchResults(true)
		})
		$('.search-button .close-icon').click(function () {
			App.HideSearchResults(true)

			// the following only partially works. A timing thing probably, as calling it from console later works
			//$('.reserve-button').click() // -> webflow code to slide over
		})

		$('#search-name').keyup(function(){
			App.SearchChanged($(this))
		})
		App.WatchSearchResultsForClick()

		$('#location .dropdown-option').click(function(){
			App.LocationSelected($(this))
		})
		$('.slider-container .dates .date').click(function(){
			App.ChangeDate($(this))
		})

		$('#multiDayBooking .dates .date').click(function(){
			App.SelectMultiDate(this)
		})

		$('#reserveModal').on('show.bs.modal', function (event) {
			var $hotspot = $(event.relatedTarget) // hotspot that triggered the modal
			//var modal = $(this)
			//modal.find('.modal-body input').val(recipient)
			App.OpenModal($hotspot)
		})

		$('#reserveButton').click(function(){
			App.SaveBooking()
		})
		$('#continueButton').click(function(){
			// show the normal modal but with multiple dates shown
			App.ShowNormalBookingDay()
		})
		
		$('#cancelLink').click(function(event) {
			event.preventDefault()
			App.CancelBooking()
		})
		$('#startMultiDayLink').click(function(event) {
			event.preventDefault()
			App.ShowMultiDay()
		})
	},

	ChangeDate: function($ele) {
		// change highlighted date in control
		$('.slider-container .dates .button').removeClass('active')
		$ele.addClass('active') 

		App.FetchBookings()
	},
	LocationSelected: function($ele) {
		var newMapId = $ele.data('mapid')
		var oldMapId = $('#location-selected').data('mapid')
		if(newMapId === oldMapId) return; // they didn't change it
		// go to the new page
		window.location = "/map?map=" + newMapId
	},
	SearchChanged: function($ele) {
		var searchTerm = $ele.val()
		
		if(searchTerm === '') {
			App.HideSearchResults(true)
		} else {
			App.ShowLoading(true)
			$.ajax({
				type: 'GET',
				contentType: "application/json; charset=utf-8", // default is form
				url: "/api/emaillookup",
				data: { term: searchTerm }
			})
			.fail(function(result) {
				alert('error getting people');
			})
			.done(function(results) {
				var $drop = $('#search-dropdown')
				$drop.empty()
				if (results.length === 0) {
					$drop.append(`<div class="search-result">no results...</div>`)
				} else {
					$.each(results, function(index, result) {
						$drop.append(`<div class="search-result" data-spacecode="${result.spaceCode}" data-email="${result.email}" data-mapid="${result.mapId}">${result.name}</div>`)
					})
					App.WatchSearchResultsForClick() // add events to the new items
					// could change the above to use $(dropdowncontainer).on() to always watch even new ones?
				}
				$drop.slideDown() // does nothing if already down
			})
			.always(function() {
				App.ShowLoading(false)
			})
			
		}
	},
	WatchSearchResultsForClick: function() {
		$('#search-dropdown .search-result').click(function(){
			App.SearchSelected($(this))
		})
	},
	HideSearchResults: function(doClearSearchField) {
		if (doClearSearchField) {
			$('#search-name').val('')
		}
		$('#search-dropdown').hide().empty()
	},
	SearchSelected: function($ele) {
		var personName = $ele.text().trim()
		$('#search-name').val(personName) // put the name they chose into the box
		App.HideSearchResults(false)
		// if on the right map, highlight the desk, otherwise change page and then highlight the desk
		var currentMapId = $('#location-selected').data('mapid')
		var personMap = $ele.data('mapid')
		if (personMap === 0) {
			App.ShowNoDeskAssigned(personName)
		} else if (currentMapId === personMap) {
			App.ShowPersonDesk(`pop_${$ele.data('spacecode')}`, personName)
		} else {
			window.location = `/map?map=${personMap}&e=${$ele.data('email')}`
		}
		 
	},
	SetupAutocomplete: function() {
		// this is the one in the reserve modal
		autocompleteBS([{
		    name: 'Emails',
		    debounceMS: 250,
		    minLength: 1,
		    maxResults: 10,
		    inputSource: document.getElementById('bookerName'),
			targetID: document.getElementById('employeeId'),
		    fetchURL: '/api/emaillookup?term={term}',
		    fetchMap: {id: "employeeId", name: "name"}
		}]);
	},
	
	SetupPopovers: function() {
		new bootstrap.Popover(document.body, App._PopOverOptions);
	},
	ShowPersonDesk: function(popId, noDeskName) {
		if (popId === '') {
			return
		} else if (popId === 'NoDesk') {
			App.ShowNoDeskAssigned(noDeskName)
		} else {
			//bootstrap.Popover.getInstance($(popId)).show()
			//$('#' + popId).popover().show()
			//$('#' + popId).popover('show') // works but HTML shows (try sanitize off, html on?)
			//App._PopOverList[4].show() // doesn't work
			//new bootstrap.Popover($('#' + popId)).show() // works but HTML shows
			
			var $ele = $('#' + popId)
			if ($ele.length > 0) {
				App.HideAnyShowingPopover()
				App._CurrentlyShownPopover = new bootstrap.Popover($ele, App._PopOverOptions)
				App._CurrentlyShownPopover.show()
				$ele.addClass('space-selected')
			}
		}
		
	},
	HideAnyShowingPopover: function() {
		if (App._CurrentlyShownPopover !== null) {
			$(App._CurrentlyShownPopover._element).removeClass('space-selected')
			App._CurrentlyShownPopover.hide()
		}
	},
	ChangePopoverText: function(spaceId, heading) {
		// change the popover content (not as obvious as you'd think)
		// remove and re-add
		// tried A LOT of things, this was the only way I could get it to work

		var $pop = $('#pop_' + spaceId)
		if ($pop.length === 0) {
			// this can happen if a booking is made, but the space gets set to an employee's permanent spot later
			// TODO: add validation to admin and API so this can't happen
			//alert(`spaceId ${spaceId} doesn't exist!`)
			return
		}
		var html = $pop[0].outerHTML // save the HTML
		$pop.remove() 
		
		var $newEle = $(html) // data('bs-content') becomes bsContent which won't work
		
		// change the heading
		var popContent = $newEle.attr('data-bs-content')
		const re = /<h6>[^<]+<\/h6>/
		popContent = popContent.replace(re, `<h6>${heading}</h6>`)
		
		$newEle.attr('data-bs-content',popContent)
		$('#'+spaceId).append($newEle)		
	},

	OpenModal: function($hotspot) {
		App.HideAnyShowingPopover()
		$('#reserveModalLabel').text('Reserve A Space')
		$('#multiDayBooking .date').removeClass('selected') // just do this once on openModal, save what is selected while it's open
		App.ShowNormalBookingDay()

		$('#bookerName, #employeeId').val('') // clear previous booker name //TODO: only do this in kiosk mode?

		if ($hotspot.hasClass('booked')) {
			var popContent = $('.inner', $hotspot).attr('data-bs-content')
			var reservedBy = $(popContent)[0].innerText
			App.ShowAlreadyBooked(reservedBy)
		}

		var spaceId = $hotspot.data('space-id');
		var spaceCode = $hotspot.attr('id')

		// display values
		$('#spaceCode, #multiDaySpaceCode').text(spaceCode)
		$('#spaceId').text(spaceId)

		var selectedDay = $('.control-container .dates .date.active')
		$('#reservationDisplayDate').text(selectedDay.data('date-to-display'))
		$('#reservationDate').val(selectedDay.data('date')) // store it somewhere easy to find and understand
	},
	ShowNormalBookingDay: function() {
		// called when first clicking a hotspot, also when returning from choosing multiple days
		$('#bookedByDetails, #bookingResultAlert, #singleDayResult, #multiDayBooking, #continueButton, #bookingAlert').addClass('d-none') // hide things
		$('#bookerEmailArea, #singleDayBooking, #reserveButton, #startMultiDayLink').removeClass('d-none') // show things
	},
	ShowMultiDay: function() {
		$('#singleDayBooking, #reserveButton').addClass('d-none') // hide things
		$('#multiDayBooking, #continueButton').removeClass('d-none') // show things
		$('#reserveModalLabel').text('Reserve Multiple Days')
		App.FetchBookingsForOneSpace($('#spaceId').text()) // for the next few weeks, get any bookings
	},
	SelectMultiDate: function(ele) {
		var $ele = $(ele)
		if ($ele.hasClass('disabled') || $ele.hasClass('inthepast')) {
			return
		}
		$ele.toggleClass('active')

		// get all the selected days
		var dateValues = [], datesToDisplay = []
		$('#multiDayBooking .date.active').each(function(i) {
			var $date = $(this)
			dateValues.push($date.data('date'))
			datesToDisplay.push($date.data('date-to-display'))
		})

		$('#reservationDate').val(dateValues.join(',')) // store it somewhere easy to find and understand
		$('#reservationDisplayDate').html(datesToDisplay.join('<br>'))

	},
	ShowAlreadyBooked: function(reservedBy) {
		$('#bookerEmailArea, #reserveButton, #startMultiDayLink').addClass('d-none') // hide stuff
		$('#bookedByDetails').removeClass('d-none') // show who it's booked by
		$('#bookedByDetails h4').text(reservedBy)
		$('#reserveModalLabel').text('Space Reserved')
	},
	ShowNoDeskAssigned: function(personName) {
		App.HideAnyShowingPopover()
		$('#no-desk-name').text(personName)
		var modal = new bootstrap.Modal(document.getElementById('noDeskModal'))
		modal.show()
	},

	FetchBookings: function() {
		var data = {
			date: $('.slider-container .dates .date.active').data('date'),
			mapId: $('#location-selected').data('mapid')
		}

		App.ShowLoading(true)
		$.ajax({
			type: 'GET',
			url: "/api/booking",
			data: data
		})
		.fail(function() {
			alert('error fetching bookings');
		})
		.done(function(bookings) {
			// reset any booked spaces back to normal
			$.each($('.map .outer.booked'), function(index, b) { 
				var $b = $(b)
				$b.removeClass('booked')
				App.ChangePopoverText($b.attr('id'), `Available`)
			});
			// mark all the ones sent back as booked
			$.each(bookings, function(index, b) { 
				$('#' + b.spaceCode).addClass('booked')
				App.ChangePopoverText(b.spaceCode, `Reserved by ${b.bookedByName}`)
			});
		})
		.always(function() {
			App.ShowLoading(false)
		})
	},
	FetchBookingsForOneSpace: function(spaceId) {
		$('#multiDayBooking .date').removeClass('disabled').addClass('available') // reset
		App.ShowLoading(true)
		$.ajax({
			type: 'GET',
			url: '/api/booking/forspace/'+spaceId
		})
		.fail(function() {
			alert('error fetching info on this space');
		})
		.done(function(dates) {
			$.each(dates.bookedDates, function(index, alreadyBookedDate) { 
				$('#multiDayBooking .date[data-date="' + alreadyBookedDate + '"]').removeClass('available selected').addClass('disabled')
			});
		})
		.always(function() {
			App.ShowLoading(false)
		})
	},
	SaveBooking: function() {

		var errorText = ''
		var spaceCode = $('#spaceCode').text()
		var bookerName = $('#bookerName').val()
		var employeeId = $('#employeeId').val()
		var bookingDates = $('#reservationDate').val()
		
		if (spaceCode === '') {
			errorText = 'Please go back and choose a space.'
		}
		if (bookerName === '') {
			errorText = 'Please enter your name.'
		}
		if (employeeId === '') {
			errorText = 'You must choose a name from the list. If your name does not appear, please contact HR'
		}
		if (bookingDates === '') {
			errorText = 'Please choose at least one date to reserve.'
		}
		if (errorText !== '') {
			$('#bookingAlert').removeClass('d-none')
			$('#bookingAlertMessage').text(errorText)
			return
		}

		var data = {
			bookingDates: bookingDates,
			employeeId: employeeId,
			spaceId: $('#spaceId').text(),
			mapDate: $('.control-container .dates .date.active').data('date')
		}

		App.ShowLoading(true)
		$.ajax({
			type: 'POST',
			contentType: "application/json; charset=utf-8", // default is form
			url: "/api/booking",
			data: JSON.stringify(data)
		})
		.fail(function(result) {
			if (result !== undefined && !result.isOk) {
				alert(result.errorMessage)
			} else {
				alert('error');
			}
		})
		.done(function(result) {
			$('#singleDayBooking, #reserveButton, #bookingResultAlert, .cancelBooking').addClass('d-none') // hide stuff
			$('.confirmBooking').removeClass('d-none') // show stuff
			
			// show confirmation
			var $result = $('#singleDayResult')
			$('#reserveModalLabel').text('Space Reserved')
			$result.removeClass('d-none')
			$('.spaceCode', $result).text(spaceCode)
			$('.bookingDate', $result).html($('#reservationDisplayDate').html())
			
			if (result.errorMessage !== null) {
				$('#bookingResultMessage').text(result.errorMessage)
				$('#bookingResultAlert').removeClass('d-none')
			}

			if (result.oldSpaceCode !== null) {
				// clear the old booking that's being moved
				$('#' + result.oldSpaceCode).removeClass('booked')
				App.ChangePopoverText(result.oldSpaceCode, "Available")
			}

			if(result.isOk) {
				$('#' + spaceCode).addClass('booked')
				App.ChangePopoverText(spaceCode, `Reserved by ${result.bookedByName}`)
			}
		})
		.always(function() {
			App.ShowLoading(false)
		})

	},
	CancelBooking: function() {

		var spaceCode = $('#spaceCode').text()

		var data = {
			bookingDates: $('#reservationDate').val(),
			spaceId: $('#spaceId').text()
		}

		App.ShowLoading(true)
		$.ajax({
			type: 'DELETE',
			contentType: "application/json; charset=utf-8", // default is form
			url: "/api/booking",
			data: JSON.stringify(data)
		})
		.fail(function() {
			alert( "error" );
		})
		.done(function(result) {
			$('#singleDayBooking, #reserveButton, #bookingResultAlert, .confirmBooking').addClass('d-none') // hide stuff
			$('.cancelBooking').removeClass('d-none') // show stuff
			
			// show confirmation
			var $result = $('#singleDayResult')
			$('#reserveModalLabel').text('Space Cancelled')
			$result.removeClass('d-none')
			$('.spaceCode', $result).text(spaceCode)
			$('.bookingDate', $result).html($('#reservationDisplayDate').html())
			
			if (result.errorMessage !== null) {
				$('#bookingResultMessage').text(result.errorMessage)
				$('#bookingResultAlert').removeClass('d-none')
			}

			if (result.isOk && result.oldSpaceCode !== null) {
				// clear the booking that's being cancelled
				$('#' + result.oldSpaceCode).removeClass('booked').addClass('available')
				App.ChangePopoverText(result.oldSpaceCode, "Available")
			}
		})
		.always(function() {
			App.ShowLoading(false)
		})
	},
	
	ShowLoading: function(isShow) {
		// always clear any existing
		window.clearTimeout(App._ShowLoadingTimeout)
		if (isShow) {
			// wait just a little bit or it flashes constantly
			App._ShowLoadingTimeout = window.setTimeout(function() { App._DelayedShowLoading() }, 400)
		} else {
			$('#loading').addClass('d-none')
		}
	},
	_DelayedShowLoading: function () {
		$('#loading').removeClass('d-none')
	},
	
	AutoRefreshPage: function() {
		App.FetchBookings()
		window.setTimeout(function() { App.AutoRefreshPage() }, App._AutoRefreshMinutes * 60 * 1000)
	}
}

App.init()

